package com.devi3east.bashbuddy.account.organization.domain.models

import com.devi3east.bashbuddy.common.domain.models.Address
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class Organization(
    val _id: String = "",
    val organizationName: String? = null,
    val organizationBio: String? = null,
    val contactPerson: String? = null,
    val email: String? = null,
    val phone: String? = null,
    val address: Address? = null,

    val stripeAccount: StripeAccount? = null,
    val hasAuthority: Boolean = false,
    val createdAt: Instant? = null,

    val affiliatedCount: Int = 0,

    val isPremium: Boolean = false,
    val premiumStart: Instant? = null,
    val premiumExpire: Instant? = null,

    val showFirstEventCreatedDialog: Boolean = true,

    val isActive: Boolean = true
)